import { StrictMode, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AuthProvider, useAuth } from './auth/AuthProvider.tsx'
import { AuditPage } from './pages/AuditPage.tsx'
import { BlueprintPage } from './pages/BlueprintPage.tsx'
import { DashboardPage } from './pages/DashboardPage.tsx'
import { KatalogPage } from './pages/KatalogPage.tsx'
import { KredensialLuringPage } from './pages/KredensialLuringPage.tsx'
import { LoginPage } from './pages/LoginPage.tsx'
import { NaskahPage } from './pages/NaskahPage.tsx'
import { PerangkatPage } from './pages/PerangkatPage.tsx'
import { PesertaPage } from './pages/PesertaPage.tsx'
import { ProfilPage } from './pages/ProfilPage.tsx'
import { SnapshotPage } from './pages/SnapshotPage.tsx'
import { TukPage } from './pages/TukPage.tsx'
import { Shell } from './components/Shell.tsx'
import './styles.css'

function RequireAuth({ children }: { children: ReactNode }): ReactNode {
  const { user } = useAuth()
  // Setiap keadaan pemuatan eksplisit — tanpa SSR tidak ada HTML awal, dan
  // layar kosong tidak dapat dibedakan dari aplikasi yang mati. Lihat ADR-0002.
  if (user === undefined) return <p className="boot">Memeriksa sesi…</p>
  if (user === null) return <Navigate to="/login" replace />
  return children
}

function App(): ReactNode {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireAuth>
                <Shell />
              </RequireAuth>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/profil" element={<ProfilPage />} />
            <Route path="/peserta" element={<PesertaPage />} />
            <Route path="/naskah" element={<NaskahPage />} />
            <Route path="/kredensial-luring" element={<KredensialLuringPage />} />
            <Route path="/tuk" element={<TukPage />} />
            <Route path="/perangkat" element={<PerangkatPage />} />
            <Route path="/katalog" element={<KatalogPage />} />
            <Route path="/blueprint" element={<BlueprintPage />} />
            <Route path="/snapshot" element={<SnapshotPage />} />
            <Route path="/audit" element={<AuditPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

const container = document.getElementById('root')
if (container === null) throw new Error('Elemen #root tidak ditemukan')
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
